import { useGetAiMappingRunAreaLazyQuery } from "generated/graphql";

export default function useGetAiMappingRunArea() {
  const [fetch, { data, loading, error }] = useGetAiMappingRunAreaLazyQuery();
  return [fetch, { data, loading, error }] as const;
}
